
import { type PropType, defineComponent } from "vue";

import { type NavItem } from "./types";
import { CIcon, CList, CListItem, CListItemIcon, CListItemTitle } from "../../vuetify-components";

export default defineComponent({
  components: { CIcon, CList, CListItem, CListItemTitle, CListItemIcon },
  props: {
    nuxt: {
      type: Boolean,
      default: false,
    },
    items: {
      type: Array as PropType<NavItem[]>,
      default: () => [],
    },
  },
  emits: {
    "menu-item-click": (_v: NavItem) => true,
  },
});
